import { useQuery } from '@apollo/client';
import { ORDER_BY_ID } from 'app/graphql/cart-api';
import { OrderByIdQuery } from 'app/graphql/generated/cart/graphql';
import { getStatusLabel } from 'utils/graphqlOrderStatus';

export type OrderShipment = NonNullable<OrderByIdQuery['orderByID']>['shipments'][number];

export const useOrderStatus = (orderId: string) => {
  const { data, loading } = useQuery(ORDER_BY_ID, {
    variables: { id: orderId },
  });

  const status = data?.orderByID?.status;
  const statusLabel = status ? getStatusLabel(status) : undefined;
  const shipments = data?.orderByID?.shipments ?? [];

  return { status, statusLabel, shipments, loading };
};
